import React from "react";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
const SortableItem = ({ id, children, disabled }) => {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
        id,
        disabled
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };
    return React.createElement("div", Object.assign({ ref: setNodeRef, style: style }, attributes, listeners), children);
};
export const SortableList = props => {
    const { items, renderItem, onSort, disableSort = false } = props;
    const sensors = useSensors(useSensor(PointerSensor, {
        activationConstraint: {
            distance: 8
        }
    }), useSensor(KeyboardSensor, {
        coordinateGetter: sortableKeyboardCoordinates
    }));
    function handleDragEnd(event) {
        const { active, over } = event;
        if (!over || active.id === over.id)
            return;
        const oldIndex = items.findIndex((_, idx) => `row${idx}` === active.id);
        const newIndex = items.findIndex((_, idx) => `row${idx}` === over.id);
        onSort(arrayMove(items, oldIndex, newIndex));
    }
    return React.createElement(DndContext, { sensors: sensors, collisionDetection: closestCenter, onDragEnd: handleDragEnd },
        React.createElement(SortableContext, { items: items.map((_, i) => `row${i}`), strategy: verticalListSortingStrategy },
            React.createElement("div", null, items === null || items === void 0 ? void 0 : items.map((s, i) => React.createElement(SortableItem, { key: `row${i}`, id: `row${i}`, disabled: disableSort }, renderItem(s, i))))));
};
